require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-visualization-data-visualization-with-d-3-add-labels-to-scatter-plot-circles.json") })
        }
      }, "path---data-visualization-data-visualization-with-d-3-add-labels-to-scatter-plot-circles");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-visualization-data-visualization-with-d-3-add-labels-to-scatter-plot-circles!./.cache/json/data-visualization-data-visualization-with-d-3-add-labels-to-scatter-plot-circles.json
// module id = 1953
// module chunks = 231608221292675